import React from "react";
import { Form, FloatingLabel, InputGroup, Row } from "react-bootstrap";
import { ArrowLeft, Eye, EyeSlash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

import { PasswordResetUIProps } from "./PasswordReset.types.tsx";

import { SubHeaderLabel, HeaderLabel, GreenLabel } from "../Labels.tsx";
import { ActionButton, ShowPasswordButton } from "../Buttons.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

const PasswordResetFormUI: React.FC<PasswordResetUIProps> = ({
  formData,
  validated,
  showConfirmPassword,
  showPassword,
  handleChange,
  handleShowConfirmPassword,
  handleShowPassword,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const { loadingComponent, setCurrentView, isLoading } = useLoginContext();

  if (isLoading) return loadingComponent;

  return (
    <Row style={{ maxWidth: 400 }} className="mx-auto">
      <HeaderLabel>{t("passwordReset.title")}</HeaderLabel>
      <SubHeaderLabel>{t("passwordReset.subtitle")}</SubHeaderLabel>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <InputGroup>
          <FloatingLabel
            controlId="floatingPassword"
            label={t("passwordReset.passwordLabel")}
            className="mb-3"
          >
            <Form.Control
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder=""
              value={formData.password}
              onChange={handleChange}
              required
              minLength={6}
            />
            <Form.Control.Feedback type="invalid">
              {t("passwordReset.passwordInvalid")}
            </Form.Control.Feedback>
          </FloatingLabel>

          <ShowPasswordButton role="button" onClick={handleShowPassword}>
            {showPassword ? <EyeSlash /> : <Eye />}
          </ShowPasswordButton>
        </InputGroup>

        <InputGroup>
          <FloatingLabel
            controlId="floatingConfirmPassword"
            label={t("passwordReset.confirmPasswordLabel")}
            className="mb-3"
          >
            <Form.Control
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder=""
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              minLength={6}
              isInvalid={validated && formData.password !== formData.confirmPassword}
            />
            <Form.Control.Feedback type="invalid">
              {formData.password !== formData.confirmPassword
                ? t("passwordReset.passwordsDoNotMatch")
                : t("passwordReset.confirmPasswordInvalid")}
            </Form.Control.Feedback>
          </FloatingLabel>

          <ShowPasswordButton role="button" onClick={handleShowConfirmPassword}>
            {showConfirmPassword ? <EyeSlash /> : <Eye />}
          </ShowPasswordButton>
        </InputGroup>

        <ActionButton type="submit">{t("passwordReset.resetButton")}</ActionButton>

        <GreenLabel onClick={() => setCurrentView("login")}>
          <ArrowLeft />
          {t("passwordReset.backToLogin")}
        </GreenLabel>
      </Form>
    </Row>
  );
};

export default PasswordResetFormUI;
